module.exports = __webpack_public_path__ + "img/IT0000105944303.6419fc37.png";